import { createContext, useContext } from 'react';
export const PageContext = createContext({
    stickyStyle: {},
    scrollableContentRef: { current: null },
});
export const usePageContext = () => useContext(PageContext);
//# sourceMappingURL=PageContext.js.map